import React from 'react';
import { HelpCircle, AlertTriangle, DollarSign, Wrench, Thermometer, Droplets } from 'lucide-react';
import { Card, CardContent } from '../ui/Card';
export function MaterialObjectionsSection() {
  const objections = [{
    icon: AlertTriangle,
    question: 'Will concrete crack?',
    answer: 'It can, if the base prep, mix design, or control joints are wrong. With proper engineering, cracking is controlled and cosmetic, not structural. We design for Ontario freeze-thaw cycles.'
  }, {
    icon: Grid,
    question: 'Will pavers shift or settle?',
    answer: 'They can, if the base is not compacted properly or edge restraints are missing. A well-built paver system with proper base depth and polymeric sand stays put for decades.'
  }, {
    icon: Thermometer,
    question: 'Will asphalt get soft from the heat?',
    answer: 'It can if cables are too close to the surface or installation temperature is not managed. We only recommend asphalt when the engineering supports it.'
  }, {
    icon: Droplets,
    question: 'Will salt ruin my surface?',
    answer: 'Salt accelerates wear on ALL materials. The good news: heated driveways need far less salt. We will advise on salt-safe practices for your specific material.'
  }, {
    icon: DollarSign,
    question: 'Is one material cheaper now but costly later?',
    answer: 'Yes. Asphalt is cheapest upfront but needs resealing every 2-3 years and replacement sooner. Concrete and pavers cost more initially but last 2-3x longer with less maintenance.'
  }, {
    icon: Wrench,
    question: 'What if you need to access the heating system later?',
    answer: 'With pavers, you lift and replace. With concrete, it requires cutting and patching (rare but possible). We document every cable/tube run with photos and as-built drawings so we know exactly where everything is.'
  }];
  // Helper component for Grid icon since it's not imported above
  function Grid(props: any) {
    return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-669">
        <rect width="18" height="18" x="3" y="3" rx="2" data-id="element-670" />
        <path d="M3 9h18" data-id="element-671" />
        <path d="M9 21V9" data-id="element-672" />
      </svg>;
  }
  return <section className="py-16 bg-white md:py-24" data-id="element-673">
      <div className="container mx-auto px-4 md:px-6" data-id="element-674">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-675">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-676">
            Your Biggest Concerns, Answered Honestly
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-677">
            We don't shy away from the tough questions. Here is the truth about
            material performance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-678">
          {objections.map((item, index) => <Card key={index} className="border-slate-200 hover:shadow-md transition-shadow h-full" data-id="element-679">
              <CardContent className="p-6 pt-8 h-full flex items-center justify-center" data-id="element-680">
                <div className="flex flex-col items-center text-center gap-4" data-id="element-681">
                  <div className="shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary" data-id="element-682">
                    <item.icon className="h-5 w-5" data-id="element-683" />
                  </div>
                  <div data-id="element-684">
                    <h3 className="font-bold text-slate-900 mb-2 text-base" data-id="element-685">
                      {item.question}
                    </h3>
                    <p className="text-slate-600 text-sm leading-relaxed" data-id="element-686">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}